
import BackButtonOutlined from "./back-button-outlined.vue";

export default {
  components: { BackButtonOutlined },
  props: {
    title: {
      type: String,
      default: "Title"
    }
  }
};
